/** Helpers for document editor leave-guard and connectivity. */

export function normalizeTagsText(tagsText: string): string {
  return tagsText
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean)
    .join(", ");
}

export function tagsFromText(tagsText: string): string[] {
  return tagsText
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean);
}

export function isDocsContentDirty(opts: {
  hydrated: boolean;
  bodyMd: string;
  title: string;
  tagsText: string;
  serverBody?: string;
  serverTitle?: string;
  serverTags?: string[];
}): boolean {
  if (!opts.hydrated) return false;
  const serverTags = normalizeTagsText((opts.serverTags || []).join(", "));
  return (
    opts.bodyMd !== (opts.serverBody || "") ||
    opts.title !== (opts.serverTitle || "") ||
    normalizeTagsText(opts.tagsText) !== serverTags
  );
}

export function isConnectivityError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err || "");
  if (/failed to fetch|networkerror|aborterror|load failed|network request failed/i.test(msg)) {
    return true;
  }
  if (/^50[234]:/.test(msg)) return true;
  if (/serwer chwilowo niedostępny/i.test(msg)) return true;
  return false;
}

export async function probeServerHealth(timeoutMs = 4000): Promise<boolean> {
  const ctrl = new AbortController();
  const timer = window.setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch("/api/health", {
      credentials: "include",
      signal: ctrl.signal,
      cache: "no-store",
    });
    return res.ok;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timer);
  }
}
